import React, { forwardRef, useMemo } from "react";
import {
  dashboardItems,
  NavbarItems,
} from "./constants/Dropdown.constants.tsx";
import Icon from "../../../core/components/Icon.tsx";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import RotaItem from "./components/DropdownRotaItem.tsx";
import {
  DashboardItemsEnum,
  NavbarItemsEnum,
} from "./interfaces/Dropdown.enum.ts";
import DropdownSection from "./components/DropdownSection.tsx";
interface DropdownDashboardProps {
  ref: React.RefObject<HTMLDivElement>;
}

const DropdownDashboard = forwardRef<HTMLDivElement, DropdownDashboardProps>(
  ({ }, ref) => {
    const dashboardSections = NavbarItems[NavbarItemsEnum.DASHBOARD].sections;


    const dashboardItems =
      dashboardSections[DashboardItemsEnum.DASHBOARD].items;

    const indicadoresItems =
      dashboardSections[DashboardItemsEnum.INDICADORES].items;

    const memorizedDashboardItems = useMemo(() => {
      return dashboardItems.map((item) => (
        <div key={`dashboard-${item.rota}`} className="botao-menu-cte">
          <RotaItem key={`dashboard-${item.rota}`} item={item} />
        </div>
      ));
    }, [dashboardItems]);

    const memorizedIndicadoresItems = useMemo(() => {
      return indicadoresItems.map((item) => (
        <div key={`indicadores-${item.rota}`} className="botao-menu-cte">
          <RotaItem key={`indicadores-${item.rota}`} item={item} />
        </div>
      ));
    }, [indicadoresItems]);

    return (
      <div className="dropdown-content-emb" ref={ref}>
        <div className="separador-menu-dashboard" />
        <div className="content-menu-rows">
          <DropdownSection
            titleSection={
              dashboardSections[DashboardItemsEnum.DASHBOARD].titleSection
            }
            icon={dashboardSections[DashboardItemsEnum.DASHBOARD].icon}
          >
            {memorizedDashboardItems}
          </DropdownSection>
          <DropdownSection
            titleSection={
              dashboardSections[DashboardItemsEnum.INDICADORES].titleSection
            }
            icon={dashboardSections[DashboardItemsEnum.INDICADORES].icon}
          >
            {memorizedIndicadoresItems}
          </DropdownSection>
        </div>
      </div>
    );
  }
);

export default DropdownDashboard;
